import { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Dialog } from "@mui/material";
import { getRelationMapping, getRelationships, post_Relation } from "../../../services/relation";
import CustomerSelectWrapper from "../../carrental/reservations/CustomerSelectWrapper";
import baseURL from "../../../configs/api";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import AddNewCustomer from "./AddNewCustomer";
import { useTheme } from "../../../components/hooks/useTheme";
import colorConfigs from "../../../configs/colorConfigs";
import useAuth from "../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";

type AddRelationProps = {
  handleAllRelationShowClick: () => void;
  showPopup: boolean;
  customerData: any;
  setRefreshRelation: (value: boolean) => void;
};

export const AddRelation = (props: AddRelationProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { theme, themeStyles } = useTheme();
  const [contactId, setContatctId] = useState<string>("0");
  const [relations, setRelations] = useState<any[]>([]);
  const [relationId, setRelationId] = useState<string>("0");
  const [pageNo, setPage] = useState<number>(-1);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [isNextPageLoading, setNextPageLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [pleaseWait, setPleaseWait] = useState<boolean>(false);
  const [allRelationMapping, setAllRelationMapping] = useState<any[]>([]);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

  useEffect(() => {
    if (props.showPopup) {
      getRelationMapping(tenantId)
        .then((data: any) => {
          setAllRelationMapping(data)
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showPopup])

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;
    setHasNextPage(true);
    setNextPageLoading(false);
    setPage(-1);
    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        setIsSearching(false);
        setOptions([]);
      }, 1000);
    } else {
      setOptions([]);
      setIsSearching(false);
    }

    return () => clearTimeout(timeOutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const loadNextPage = () => {
    if (searchValue === "") {
      loadWithOutSearchOptions(pageNo + 1);
    } else {
      loadWithSearchOptions(pageNo + 1);
    }
  };

  const loadWithOutSearchOptions = (page: number) => {
    try {
      const pagination = {
        page: page,
        size: 15,
      };
      setNextPageLoading(true);
      fetch(`${baseURL}Customer/GetCustomersPaging/${pagination.page},${pagination.size}`, {
        method: "GET",
        headers: {
          'X-Tenant-ID': tenantId,
           "Content-Type": "application/json" 
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const dataOptions = data.customers.map((item: any) => {
            return {
              value: item.id,
              label: item.firstName + " " + item.lastName,
            };
          });

          const itemsData = options.concat(dataOptions);
          setOptions(itemsData);
          setNextPageLoading(false);
          setHasNextPage(itemsData.length < data.count);
          setPage(page);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } catch (error) {
      handleTenantError(error);
    }
  };

  const loadWithSearchOptions = (page: number) => {
    try {
      const pagination = {
        page: page,
        size: 15,
      };
      setNextPageLoading(true);
      fetch(`${baseURL}Customer/GetCustomersSearchWithCustomerNamePaging?customerName=${searchValue}&page=${pagination.page}&size=${pagination.size}`, {
        method: "GET",
        headers: {
          'X-Tenant-ID': tenantId,
           "Content-Type": "application/json" 
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const dataOptions = data.customers.map((item: any) => {
            return {
              value: item.id,
              label: item.firstName + " " + item.lastName,
            };
          });

          const itemsData = options.concat(dataOptions);
          setOptions(itemsData);
          setNextPageLoading(false);
          setHasNextPage(itemsData.length < data.count);
          setPage(page);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } catch (error) {
     handleTenantError(error);
    }
  };

  useEffect(() => {
    getRelationships(tenantId)
      .then((data) => {
        setRelations(
          data.map((item: any) => {
            return {
              value: item.id,
              label: item.relationName,
            }
          }))
          handleTenantError(null);
      })
      .catch((error) => {
       handleTenantError(error);
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const addSecondRelation = () => {
    post_Relation({
      customerIdOne: contactId,
      customerIdTwo: props.customerData.id,
      relationshipId: relationId,
    }, auth?.id, tenantId)
      .then(() => {
        setPleaseWait(false);
        props?.handleAllRelationShowClick();
        props?.setRefreshRelation(true);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWait(false);
        handleTenantError(error);
      })
  }

  const handleSubmit = () => {
    if (parseInt(contactId) > 0 && parseInt(relationId) > 0) {
      setPleaseWait(true);
      const relationMapping = allRelationMapping?.find((item: any) => item?.relationshipIdOne === relationId);

      if (relationMapping) {
        post_Relation({
          customerIdOne: props.customerData.id,
          customerIdTwo: contactId,
          relationshipId: relationMapping?.relationshipIdTwo,
        }, auth?.id, tenantId)
          .then(() => {
            addSecondRelation()
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWait(false);
           handleTenantError(error);
          })
      } else {
        console.error("reltaion mapping not found");
      }
    }
  }


  return (
    <>
      <Dialog
        open={props.showPopup}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '500px',
            width: '100%',
            borderRadius: '16px',
          },
        }}
      >
        <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320.591 320.591"
            className={`w-3 cursor-pointer float-right ${closeIconFill}`}
            onClick={() => props.handleAllRelationShowClick()}
          >
            <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
            <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
          </svg>
          <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
            <div className="w-full mt-2">
              <div className={`w-full`}>
                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                  <div className="flex items-center gap-1.5">
                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Relation</h2>
                  </div>
                </div>

                <div className="mt-2 p-2">
                  <div className="w-full">
                    <div className="grid grid-cols-2 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>First Name</label><br />
                          <span className={`text-xs font-medium ${themeStyles.form.tailwindInputTextColor}`}>{props.customerData?.firstName}</span>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Contact</label>
                          <CustomerSelectWrapper
                            hasNextPage={hasNextPage}
                            isNextPageLoading={isNextPageLoading}
                            setSearchValue={setSearchValue}
                            options={options}
                            selectedOption={selectedOption}
                            setPage={setPage}
                            loadNextPage={loadNextPage}
                            isSearching={isSearching}
                            setIsSearching={setIsSearching}
                            onChange={(selectedOption: any) => {
                              setContatctId(selectedOption?.value)
                              setSelectedOption(selectedOption);
                            }}
                            baseWidth="100%"
                          />
                          <span
                            className="text-xs text-[#167AC3] inline-block hover:underline cursor-pointer font-medium group-hover:font-bold group-hover:scale-125"
                            onClick={() => setShowPopup(true)}
                          >
                            Add New Contact
                          </span>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Name</label><br />
                          <span className={`text-xs font-medium ${themeStyles.form.tailwindInputTextColor}`}>{props.customerData?.lastName}</span>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Relation</label>
                          <Select
                            menuPortalTarget={document.body}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: "transparent",
                                color: themeStyles.form.inputTextColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "14px",
                                backgroundColor: themeStyles.main.mainBg,
                                color: themeStyles.form.inputTextColor,
                              }),
                              menuPortal: base => ({ ...base, zIndex: 9999 }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? "#167AC3"
                                  : state.isFocused
                                    ? themeStyles.topBar.menuItemsHoverColor
                                    : "transparent",
                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                fontWeight: 600
                              }),
                              input: (base) => ({
                                ...base,
                                color: themeStyles.form.inputTextColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.form.inputTextColor,
                              }),
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="relation"
                            value={relations.find((item) => item.value === relationId)}
                            onChange={(e: any) =>
                              setRelationId(e ? e.value : "")
                            }
                            options={relations}
                          />

                        </div>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={props.handleAllRelationShowClick}
                      >
                        Cancel
                      </Button>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {
        showPopup && (
          <AddNewCustomer
            showPopup={showPopup}
            setShowPopup={setShowPopup}
            setSelectedOption={setSelectedOption}
            setContatctId={setContatctId}
          />
        )
      }

      <PleaseWaitPopup pleaseWaitPopup={pleaseWait} />
    </>
  );
};
